module.exports = __webpack_public_path__ + "img/standardXDYL.17aa737f.png";